// export function getDayBefore(day: string) {
//     let date = new Date(day);
//     date.setDate(date.getDate() - 1);
//     return date.toISOString().split('T')[0];
// }
//
// export function getDayAfter(day: string) {
//     let date = new Date(day);
//     date.setDate(date.getDate() + 1);
//     return date.toISOString().split('T')[0];
// }

import {get} from "svelte/store";
import {_} from "svelte-i18n";

export function getDayOfWeekForGivenDay(day: string) {
    let date = new Date(day);
    return date.toLocaleString('default', { weekday: 'long' });
}

export function returnOnlyDayAndMonth(day: string) {
    let date = new Date(day);
    return date.toLocaleString('default', { day: 'numeric', month: 'short' });
}

export function getHumanFriendlyDateDifferenceForToday(date: string, useSimpleFormatForFarDates = true) {
    const difference = getDateDifferenceInDays(date);
    if (difference === -1 ) {
        return get(_)('yesterday');
    }
    if (difference < -1 ) {
        return get(_)('{count} days ago', {values: {count: -difference}});
    }
    if (difference === 0) {
        return get(_)('today');
    } else if (difference === 1) {
        return get(_)('tomorrow');
    } else if (difference === 2) {
        return get(_)('day after tomorrow');
    } else if (difference>=3 && difference<7) {
        return getDayOfWeekForGivenDay(date);
    } else if (useSimpleFormatForFarDates) {
        return returnOnlyDayAndMonth(date);
    }
    return '';
}

export function getOutputFormattedDate(date: string) {
    // output as DD-MM
    let dateObj = new Date(date);
    let str = dateObj.getDate() + '.' + (dateObj.getMonth() + 1)
    // add leading zero for month
    return str.replace(/\.(\d)$/, '.0$1');
}

export function getHumanFriendlyTimeDuration(seconds: number) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds - (hours * 3600)) / 60);
    if (hours === 0) {
        return '0 h ' + minutes; // + 'min';
    }
    return hours + ' h ' + minutes; // + 'min';
}

export function getDateDifferenceInDays(dateString:string) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const otherDate = new Date(dateString);
    otherDate.setHours(0, 0, 0, 0);

    const diffInMs = (otherDate.getTime() - today.getTime());
    return Math.round(diffInMs / (1000 * 60 * 60 * 24));
}